import { CookieCategory } from "./cookie-consent.types";

type ConsentEffect = {
  onGrant: () => void;
  onDeny: () => void;
};

const registry: Partial<Record<CookieCategory, ConsentEffect>> = {};

export function registerConsentEffect(category: CookieCategory, effect: ConsentEffect) {
  registry[category] = effect;
}

export function getConsentEffect(category: CookieCategory) {
  return registry[category];
}
